import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Mail = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.38 4H2.62C2.28 4 2 4.28 2 4.62V19.38C2 19.72 2.28 20 2.62 20H21.38C21.72 20 22 19.72 22 19.38V4.62C22 4.28 21.72 4 21.38 4ZM20.04 5.23L13.4 10.85C12.57 11.55 11.42 11.55 10.59 10.85L3.96 5.23H20.04ZM3.23 18.77V6.23L9.8 11.79C10.45 12.34 11.22 12.61 12 12.61C12.78 12.61 13.55 12.34 14.2 11.79L20.76 6.23V18.77H3.23Z" />
  </svg>
)

export default withDefaultStyles(Mail)
